export const sanitizeCnpj = (value) => {
  if (!value) return ''

  return value.toString().toUpperCase().replace(/[^0-9A-Z]/g, '')
}

export const cnpjValidator = (value) => {
  if (!value) return false

  const validTypes =
    typeof value === 'string' || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false

  const cnpj = sanitizeCnpj(value)

  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false

  const chars = [ ...cnpj ]

  if (new Set(chars).size === 1) return false

  const values = chars.map((char) => char.charCodeAt(0) - 48)

  const calc = (x) => {
    const slice = values.slice(0, x)
    let factor = x - 7
    let sum = 0

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i]

      sum += n * factor--
      if (factor < 2) factor = 9
    }

    const result = 11 - (sum % 11)

    return result > 9 ? 0 : result
  }

  const digits = values.slice(12)
  const digit0 = calc(12)

  if (digit0 !== digits[0]) return false

  const digit1 = calc(13)

  return digit1 === digits[1]
}
